import { getYouTubeId } from "../../lib/helpers";
import { SchemaVideoObject } from "../schema-video-object";

const Embed = ({ url }) => {
  const id = getYouTubeId(url);
  return (
    <div className="embed-responsive aspect-ratio-16/9 shadow-2xl mb-6">
      <iframe
        title={`Embedded YouTube Video`}
        src={`https://www.youtube.com/embed/${id}?rel=0`}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen=""
      />
      <SchemaVideoObject
        name={"Embedded Youtube Video"}
        description={""}
        embedUrl={`https://www.youtube.com/embed/${id.trim()}?rel=0`}
        thumbnail={`https://img.youtube.com/vi/${id.trim()}/maxresdefault.jpg`}
      />
    </div>
  );
};

export default Embed;
